import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.css',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent {
  readonly activeModal = inject(NgbActiveModal);

  public title = '';
  public message = '';

  /**
   * Optional warning shown in red below the message, with any details listed under it
   */
  public warning = '';
  public warningDetails: string[] = [];

  yes() {
    this.activeModal.close(true);
  }

  no() {
    this.activeModal.close(false);
  }

  close() {
    this.activeModal.close(false);
  }
}
